<div class="modal-header">
  <h5 class="modal-title" *ngIf="isAdd">Добавление сведений о доходах члена семьи</h5>
  <h5 class="modal-title" *ngIf="!isAdd">Редактирование сведений о доходах члена семьи</h5>
  <button type="button" class="close" mat-dialog-close style="outline: none">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body property-window" style="max-height: 600px; overflow-y: auto">

  <app-income-object-adder
    [idFinanceDocument]="idFinanceDocument"
    [isParent]="false"
    [parentMemberDocument]="parentMemberDocument"
    (exit$)="off()"
    (financeDocument$)="getFinanceDocument($event)">
  </app-income-object-adder>

</div>

